<template>
  <VInput class="df-checkbox" :value="model" :rules="rules">
    <NsCheckbox v-model="model" class="input-checkbox">
      <template #label>
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div v-html="schema.label" />
      </template>
    </NsCheckbox>
  </VInput>
</template>

<script>
/**
 * Original Author: Aaron Turnblom
 * Original Team: Area 51
 */
import { VInput } from 'vuetify/lib';
import NsCheckbox from '../../NsCheckbox.vue';

import { PropsMixin, ModelMixin } from '../mixins';

export default {
  components: {
    NsCheckbox,
    VInput,
  },
  mixins: [PropsMixin, ModelMixin({ deep: false })],
  props: {
    /**
     * Field value
     * @type {object}
     */
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    requiredMessage() {
      // The AEM service sets up a validation rule with this regex if the field is required.
      const requiredRegex = '/^[^]+$/';
      // Since the regex doesn't work well with a boolean value, we extract
      // the error message from the validation rule. We'll set up a rule which uses
      // the message.
      const validation = this.schema.validation || [];
      const requiredRule = validation.find(
        ({ regex }) => regex === requiredRegex
      );
      return requiredRule ? requiredRule.error : null;
    },
    rules() {
      const requiredMessage = this.requiredMessage;
      if (requiredMessage) {
        return [(value) => value || requiredMessage];
      } else {
        return [];
      }
    },
  },
};
</script>
<style scoped lang="scss">
.input-checkbox {
  margin-top: 8px;
  flex: 1;
}
</style>
